import { FC } from 'react';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import ParticipantMessage from './ParticipantMessage';

type Props = {
  message: HeroConversationMessage;
};

const NeedSelectedMessage: FC<Props> = ({ message }) => {
  return (
    <ParticipantMessage message={message}>
      Needs help with: <strong>{message.body}</strong>
    </ParticipantMessage>
  );
};

export default NeedSelectedMessage;
